import * as React from 'react';
import { useField } from 'react-final-form';
import Select from '../../Select/Select';

interface Props {
	disabled?: boolean;
}

const SelectType: React.FunctionComponent<Props> = props => {
	const field = useField('type', {
		type: 'select'
	})

	return <Select
		label="Перенести в"
		value={field.input.value}
		className="edit__section__field"
		onChange={(event) => {
			field.input.onChange(event);
		}}
		onBlur={(event) => {
			field.input.onBlur(event);
		}}
		disabled={props.disabled}
		items={[
			{
				value: 'read_now',
				label: 'Читаю сейчас'
			},
			{
				value: 'already_read',
				label: 'Прочитано'
			},
			{
				value: 'want_read',
				label: 'Хочу прочитать'
			}
		]}
	/>;
};

export default SelectType;